'use client';

import { ReactNode, useEffect, useRef, useState } from 'react';

/** 애니메이션 전환 시간 (ms) */
const TRANSITION_DURATION = 300;

interface AnimatedBannerWrapperProps {
  /** 배너 노출 여부 */
  isVisible: boolean;
  children: ReactNode;
}

/** 콘텐츠 높이를 자동 측정하여 높이 전환 애니메이션을 적용하는 배너 래퍼 */
const AnimatedBannerWrapper = ({
  isVisible,
  children,
}: AnimatedBannerWrapperProps) => {
  const [height, setHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  /** ResizeObserver로 콘텐츠 높이 변화를 실시간 감지 */
  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      if (!isVisible) {
        setHeight(0);
        return;
      }
      const measured = el.scrollHeight;
      if (measured > 0) {
        setHeight(measured);
      }
    });

    observer.observe(el);

    return () => observer.disconnect();
  }, [isVisible]);

  return (
    <div
      style={{
        height,
        overflow: 'hidden',
        transition: `height ${TRANSITION_DURATION}ms ease-in-out`,
      }}
    >
      <div ref={contentRef} style={{ lineHeight: 0 }}>
        {children}
      </div>
    </div>
  );
};

export default AnimatedBannerWrapper;
